export default __webpack_public_path__ + "static/media/artistBanner.39cc1a7a.jpg";